/**
 * NPM Token patterns:
 *
 * NPM tokens are used for authenticating with the NPM registry.
 * They can appear in .npmrc files or as environment variables.
 *
 * Patterns:
 * 1. NPM Auth Token (legacy):
 *    - Base64 encoded string
 *    - Usually found as _auth= in .npmrc
 *
 * 2. NPM Access Token:
 *    - UUID format with npm_ prefix or without
 *    - Found as //registry.npmjs.org/:_authToken=
 *
 * 3. NPM Legacy Token:
 *    - 36-character UUID
 *    - Format: xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx
 *
 * Examples:
 * - `//registry.npmjs.org/:_authToken=npm_1234567890abcdef1234567890abcdef12345678`
 * - `_auth=YWRtaW46cGFzc3dvcmQ=`
 * - `NPM_TOKEN=12345678-1234-1234-1234-123456789abc`
 *
 * References:
 * - https://github.com/secretlint/secretlint/blob/master/packages/%40secretlint/secretlint-rule-npm/src/index.ts
 * - https://docs.npmjs.com/about-authentication-tokens
 * - https://docs.npmjs.com/using-private-packages-in-a-ci-cd-workflow
 */

export const npmAccessToken = /:_authToken=\s*(?:npm_)?([a-fA-F0-9-]{36,})/;
export const npmAuthToken = /_auth\s*=\s*([A-Za-z0-9+/=]{20,})/;
export const npmTokenEnv =
  /\b(?:NPM_TOKEN|npm_token)["']?\s*[:=]\s*["']?([a-fA-F0-9-]{36})["']?/i;
